import { createContext, useContext } from '@wordpress/element';
export const ItemGroupContext = createContext({
  isList: false,
  size: 'medium'
});
ItemGroupContext.displayName = 'ItemGroupContext';
export const useItemGroupContext = () => useContext(ItemGroupContext);